import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const RichTextIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "RichText",
    children: /*#__PURE__*/_jsx("path", {
      d: "M3.25 17.01c.11.05.23.07.37.07.46 0 .85-.29 1-.69s.93-2.53.93-2.53h5.78l.97 2.54c.16.41.55.7 1 .7.6 0 1.07-.48 1.07-1.07 0-.14-.02-.27-.07-.39S9.38 2.69 9.38 2.69c-.04-.07-.08-.14-.13-.2-.04-.06-.07-.11-.11-.15s-.09-.07-.15-.09a.5.5 0 0 0-.2-.13h-.16s-.07-.01-.12-.01c-.04 0-.08 0-.12.01s-.06-.01-.11-.01-.08 0-.12.01h-.15c-.07.04-.13.07-.19.12-.06.04-.12.08-.16.12s-.06.08-.08.13c-.08.06-.14.12-.2.19L2.63 15.61c-.05.12-.07.26-.07.4 0 .46.28.84.69 1M8.4 6.14l2.16 5.54H6.31zM17.62 2h10.77a1.071 1.071 0 0 1 0 2.14H17.62a1.071 1.071 0 0 1 0-2.14M17.62 8.47h10.77a1.071 1.071 0 0 1 0 2.14H17.62a1.071 1.071 0 0 1 0-2.14M17.62 14.93h10.77a1.071 1.071 0 0 1 0 2.14H17.62a1.071 1.071 0 0 1 0-2.14M3.61 21.4h24.78a1.071 1.071 0 0 1 0 2.14H3.61a1.071 1.071 0 0 1 0-2.14M3.61 27.85h24.78a1.071 1.071 0 0 1 0 2.14H3.61a1.071 1.071 0 0 1 0-2.14"
    })
  }));
};